import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, setPersistence, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyDXzsUGF57r57GEMURC2JOY5wvfq4G2UPI",
  authDomain: "casa-connect-44530.firebaseapp.com",
  projectId: "casa-connect-44530",
  storageBucket: "casa-connect-44530.appspot.com",
  messagingSenderId: "411723597088",
  appId: "1:411723597088:web:0c13c125a2930b52ba4345",
  measurementId: "G-64BHRRDK2N"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

setPersistence(auth, browserLocalPersistence);

export { app, analytics, auth, db, functions };